import React,{useEffect} from 'react'
import "./blog.css"
import {BsArrowRightShort} from "react-icons/bs";

import Aos from 'aos';
import 'aos/dist/aos.css';

import img14 from "../../assets/blog/camel.jpg"
import img15 from "../../assets/blog/tajine.jpg"
import img16 from "../../assets/blog/atlas.jpg"
import img17 from "../../assets/blog/fez3.jpg"


const Posts = [
 {
  id:1,
  postImage:img14,
  Title: "Camel is the best animal in Moroccan sahara",
  desc: "Morocco has a unique ecosystem that includes camels as one of its main inhabitants.",
 },
 {
  id:2,
  postImage:img15,
  Title:"The Big secret how to making delicious tagine",
  desc:"Tagine is a traditional North African dish made with slow cooked meat and spices over a low heat."
 },
 {
  id:3,
  postImage:img16,
  Title:"The best hiking trails in the Atlas mountains",
  desc:"The Atlas mountains are a great place for hiking, with numerous trails ranging from easy to challenging."
 },
 {
  id:4,
  postImage:img17,
  Title:"Fez is the heart of Marrakech, let’s explore it!",
  location:'Fez',
  desc: `Fez is an ancient city located in Morocco, known for its bustling streets filled with colorful markets and historic landmarks.`
}
]

const Blog = () => {

  useEffect(()=>{
    Aos.init({duration:2000});
  },[])


  return (
    <div id='Blog'>
      <section className="blog container section">
        <div className="secContainer">
          <div className="secIntro">
            <h2 data-aos="fade-up" data-aos-duration="2000" className="secTitle">
              Our Best Blog?
            </h2>
            <p data-aos="fade-up" data-aos-duration="2500">An insight to the incredible experience in the world!</p>
          </div>
          <div className="mainContent grid">
            {
              Posts.map(({id,postImage,Title,desc})=>{
                return(
                  <div data-aos="fade-up" data-aos-duration="2000" className="singlePost grid">
                    <div className="imgDiv">
                      <img src={postImage} alt={Title} />
                    </div>
                    <div className="postDetails">
                      <h3 data-aos="fade-up" data-aos-duration="3000">{Title}</h3>
                      <p data-aos="fade-up" data-aos-duration="4000">{desc}</p>
                    </div>
                    <a href="#" data-aos="fade-up" data-aos-duration="4500" className="flex">
                    Read More
                      <BsArrowRightShort className='icon'/>
                    </a>
                  </div>
                )
              })
            }
          </div>
        </div>
      </section>
    </div>
  )
}

export default Blog